import { render, staticRenderFns } from "./periodoHora.vue?vue&type=template&id=fe489bea&"
import script from "./periodoHora.vue?vue&type=script&lang=js&"
export * from "./periodoHora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports